import { serviceSteps } from '@/mocks/solutionsData';
import { img, readdy } from '@/utils/images';
import ScrollReveal from '@/components/base/ScrollReveal';

export default function ServiceProcess() {
  return (
    <section className="relative bg-white py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.04]">
        <img
          src={readdy('svc-process-bg-v2')}
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="px-6 md:px-10">
        <div className="max-w-7xl mx-auto">
          <ScrollReveal variant="fade-up">
            <div className="text-center mb-14">
              <p className="text-brand-brown text-sm tracking-widest mb-3 font-medium">服务流程</p>
              <h2 className="text-3xl md:text-4xl font-bold text-brand-deep leading-tight">
                每一步，都有专业顾问陪伴
              </h2>
              <p className="text-gray-400 text-sm mt-3 max-w-xl mx-auto">
                从初次评估到长期巩固，科学规划每一个服务环节
              </p>
            </div>
          </ScrollReveal>

          <div className="relative">
            <div className="hidden lg:block absolute left-1/2 top-0 bottom-0 w-px bg-brand-cream -translate-x-1/2" />

            <div className="space-y-6 md:space-y-10">
              {serviceSteps.map((item, index) => {
                const isLeft = index % 2 === 0;
                return (
                  <ScrollReveal key={item.step} variant={isLeft ? 'fade-right' : 'fade-left'} delay={index * 80}>
                    <div className={`flex flex-col lg:flex-row items-center gap-6 lg:gap-10 ${isLeft ? 'lg:flex-row' : 'lg:flex-row-reverse'}`}>
                      <div className={`flex-1 ${isLeft ? 'lg:text-right' : 'lg:text-left'} w-full`}>
                        <div className="bg-white rounded-2xl p-6 md:p-8 border border-brand-light/40 hover:border-brand-cream hover:shadow-md transition-all duration-300">
                          <div className={`flex items-center gap-3 mb-3 ${isLeft ? 'lg:justify-end' : 'lg:justify-start'}`}>
                            <span className="text-xs font-bold text-brand-gold bg-brand-light px-3 py-1 rounded-full">
                              STEP {item.step}
                            </span>
                            <h3 className="text-lg font-semibold text-brand-deep">{item.title}</h3>
                          </div>
                          <p className="text-xs text-brand-brown mb-3">{item.subtitle}</p>
                          <p className="text-gray-500 text-sm leading-relaxed mb-4">{item.desc}</p>
                          <div className={`flex flex-wrap gap-2 ${isLeft ? 'lg:justify-end' : 'lg:justify-start'}`}>
                            {item.tags.map((tag) => (
                              <span
                                key={tag}
                                className="text-xs text-brand-dark bg-brand-light/60 px-2.5 py-1 rounded-full"
                              >
                                {tag}
                              </span>
                            ))}
                          </div>
                        </div>
                      </div>

                      <div className="relative z-10 flex-shrink-0">
                        <div className="w-14 h-14 flex items-center justify-center rounded-full bg-brand-deep text-white shadow-sm">
                          <i className={`${item.icon} text-xl`} />
                        </div>
                      </div>

                      <div className="flex-1 hidden lg:block" />
                    </div>
                  </ScrollReveal>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}